module.exports = __webpack_public_path__ + "static/media/icon_projects.f3206129.svg";